import { NETWORK, STATIC_DOMAIN, PLAYNC_DOMAIN, PURPLE_SCHEME } from "../common/const";
import Common from '../common/Common';

class PurpleUrl {
    constructor() {
    }

    goErrorPage(env) {
        const locale = window?.userData?.locale;
        const errorPageEnv = env === NETWORK.stage || env === NETWORK.live ? NETWORK.live : NETWORK.rc;
        location.href = `${STATIC_DOMAIN[errorPageEnv]}/purple/launcher/error.html?location=${locale}`;
    }

    // 퍼플 모바일앱(인앱) - 외부 브라우저로 이동
    goPurpleAppExternal(url) {
        if(!url) {
            return;
        }
        
        window.open(this.setPurpleAppScheme('external', url), '_blank'); 
    }

    async getSsoUrl(url) {
        if(!url) {
            throw new Error(`url이 존재하지 않습니다.${e}`);
        }

        const { env } = Common?.instance || {};
        const curEnv = env in PLAYNC_DOMAIN ? env : 'live';
        const encodeUrl = this.getEncodeUrl(url);

        return fetch(`${PLAYNC_DOMAIN[curEnv]}/api/session/sso?return_url=${encodeUrl}`, {
            method: 'GET',
            credentials: 'include'
        })
        .then(res => res?.json())
        .catch(e => { throw new Error(`sso url api 호출에 실패하였습니다.\n${e}`); });
    }

    async ssoUrlExternal(url) {
        if(!url) {
            throw new Error(`url이 존재하지 않습니다.${e}`);
        }
        
        const urlAddParam = this.setUrlAddPurpleParam(url);
        const { ssoUrl } = await this.getSsoUrl(urlAddParam) || {};
        
        ssoUrl && window.open(ssoUrl, '_blank'); // 외부 브라우저로 이동
    }

    getEncodeUrl(url) {
        return encodeURIComponent(url);
    }

    setPurpleAppScheme(type, url) {
        if(!!url && type in PURPLE_SCHEME) {
            const encodeUrl = this.getEncodeUrl(url);
            url = `${PURPLE_SCHEME[type]}${encodeUrl}`;
        }

        if(type === 'external') {
            url = this.setUrlAddPurpleParam(url);
        }

        return url;
    }

    checkHasParams(url) {
        let hasParam = false;
        let hasParams = false;

        if(url) {
            hasParam = (/\?.+/g).test(url); // query param 있는지 여부
            hasParams = (/\?(?=.*&).+/g).test(url); // param 2개 이상 있는지 여부
        }

        return { hasParam, hasParams };
    }

    setUrlAddPurpleParam(url) {
        const { hasParam, hasParams } = this.checkHasParams(url);
        return `${url}${!hasParam ? '?' : ''}${hasParams ? '&' : ''}from=purple`;
    }

    // 퍼플 모바일앱(인앱)일 때, 고객지원 url 뒤에 sdk=ncmtalk 파라미터 붙이기
    setCsUrlAddPurpleAppParam(url) {
        const { hasParam, hasParams } = this.checkHasParams(url);
        return `${url}${!hasParam ? '?' : ''}${hasParams ? '&' : ''}sdk=ncmtalk`;
    }
}

export default new PurpleUrl();